import React, { useEffect, useContext } from 'react';
import './deporte.scss';
import DialogContentText from '@material-ui/core/DialogContentText';
import ReactMarkdown from 'react-markdown';

// CONTEXT
import ActivitiesContext from '../../../../../contexts/pages/activities/activitiesContext';

const Deporte = () => {

    const activitiesContext = useContext(ActivitiesContext);
    const { deporte } = activitiesContext;

    useEffect(() => {
    }, [deporte])

    // console.log("from deporte",activitiesContext)

    return (
        <div className="deporte activity-subpage">
            <div className="deporte-inner act">
                <div className="deporte-title">{deporte ? deporte.titulo.toUpperCase() : "DEPORTE"}</div>
                <div className="deporte-text">
                    {deporte
                        ?
                        // <DialogContentText>
                            <ReactMarkdown>
                                {deporte.contenido}
                            </ReactMarkdown>
                        // </DialogContentText>
                        :
                        <p>
                            La Secundaria Babeque es un centro educativo auspiciado por la Fundación Pedagógica Dominicana Inc.,
                            institución sin fines de lucro creada en el año de 1977  por un grupo de madres y padres cuyos hijos
                            terminaban el sexto grado del Colegio Babeque Inicial y Primaria. Con esta iniciativa se proponían
                            velar por el desarrollo de los valores universales, la dominicanidad y la formación integral de sus hijos e hijas.

                            Se seleccionó el nombre Babeque, voz de origen taíno que significa tierra de oro, por considerar a
                            la niñez y la juventud como la esperanza y el tesoro más preciado de una nación.
                        </p>
                    }
                </div>
            </div>
        </div>
    )
}

export default Deporte;